import React from 'react';

interface TodoRoutePlaceholderProps {
  pageName: string;
}

export const TodoRoutePlaceholder: React.FC<TodoRoutePlaceholderProps> = ({ pageName }) => {
  return (
    <div style={{ padding: '2rem' }}>
      <h2 style={{ margin: 0 }}>{pageName}</h2>
      <p style={{ marginTop: '0.75rem' }}>TODO: React parcel/component mapping pending.</p>
    </div>
  );
};
